import { render, staticRenderFns } from "./RegisteredName .vue?vue&type=template&id=60970804&scoped=true"
import script from "./RegisteredName .vue?vue&type=script&lang=js"
export * from "./RegisteredName .vue?vue&type=script&lang=js"
import style0 from "./RegisteredName .vue?vue&type=style&index=0&id=60970804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60970804",
  null
  
)

export default component.exports